(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventTypeDialogController', EventTypeDialogController);

    EventTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventType'];

    function EventTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventType) {
        var vm = this;
        vm.eventType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventType.id !== null) {
                EventType.update(vm.eventType, onSaveSuccess, onSaveError);
            } else {
                EventType.save(vm.eventType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
